import CellController, { CellComponent } from '../../lib/CellController'
import CellFieldController from '../../lib/CellFieldController'
import PlannerController from './PlannerController'

export default PlannerController

/** @constructor @extends {PlannerController} @suppress {checkTypes} */ function _PlannerComponent() {}
PlannerController.__implement(
 CellFieldController,
 _PlannerComponent.prototype = /** @type {!PlannerController} */ ({
  paint() { // to availability in month/year
   const{props:{title},PlannerHeading}=this
   if(title)PlannerHeading.innerHTML=title
   // console.log(availability)
  },
 }),
 _PlannerComponent.prototype = /** @type {!PlannerController} */ ({
  // cancel(withRange=true){

  // },
  // cancelStart(withRange=true) {

  // },
  // cancelEnd(withRange=true) {

  // },
  // selectStart(start) {

  // },
  // selectEnd(end) {

  // },
  __$constructor() {
   const{asICellFieldController:{cellField}}=this

   const classes = CellComponent.getClasses(this.props.splendid)

   /** @type {!Array<!HTMLTableCellElement>} */
   const tds = [...this.querySelectorAll('td')]
   const cells = tds.map((td) => {
    const _number = td.dataset['number']
    const number = _number ? parseInt(_number, 10) : undefined
    const past = 'past' in td.dataset || undefined
    td.removeAttribute('data-date')
    td.removeAttribute('data-past')
    const cell = CellController.control(td, {
     classes,
     shadow: true,
     state: {
      past,
      // past: this.today.getDate() - number > 0,
     },
     props: {
      number,
     },
    })
    return cell
   })
   cellField.superCellField.initialiser({
    cells,
   })

   const {
    // asICalendarController:{cancel},
    asICellFieldController:{cancel,selectEnd,selectStart,project,clearProjected,setState,cancelStart},
   } = this

   for (const cell of cells) {
    const{props:{number:hour},element}=cell
    element.addEventListener('click', () => {
     const{
      asICellFieldController:{
       props:{disabled},
       occupied,
       start,end,uiState,canSelectRange, // should can select range be a property [semantic]
      },
      asIPlannerController:{
       // state:{year,month},today,
      },
     }=this
     if (disabled) return
     if (uiState=='selected') {
      cancel()
     }
     if(uiState == 'selected' || uiState=='selectingStart') {
      let h=hour
      let minH=MIN_HOURS
      let maxH=MAX_HOURS
      if(!this.props.canSelectRange) {
       maxH=22
      }
      if(h<minH)h=minH
      if(h>maxH)h=maxH

      clearProjected()
      selectStart(h)
      // instead of predefined, use range
      const endd=h+(this.props.canSelectRange?PREDEFINED_RANGE:0)
      selectEnd(endd) // automatically switches to the "selected" ui mode
      if(!this.props.canSelectRange) {
       this.setState({uiState:'selected'})
       // maxH=22
      }
      // setState({end:endd,uiState:'selected'})
     }
    })
    element.addEventListener('mouseenter',() => {
     const{
      asICellFieldController:{
       uiState,
      },
     }=this
     if(uiState=='selectingStart') {
      let h=hour
      let minH=MIN_HOURS
      let maxH=MAX_HOURS
      if(!this.props.canSelectRange) {
       maxH=22
      }
      if(h<minH)h=minH
      if(h>maxH)h=maxH
      project(h+this.props.canSelectRange?PREDEFINED_RANGE:0,h)
     }
    })
    element.addEventListener('mouseleave', () => {
     const{
      asICellFieldController:{
       uiState,
      },
     }=this
     if (uiState == 'selectingStart') {
      clearProjected()
     }
    })
   }
  },
 }),
)

const MIN_HOURS = 10
const MAX_HOURS = 17
const PREDEFINED_RANGE = 5